'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdpAdp = function (_React$Component) {
  _inherits(AdpAdp, _React$Component);

  function AdpAdp() {
    _classCallCheck(this, AdpAdp);

    return _possibleConstructorReturn(this, (AdpAdp.__proto__ || Object.getPrototypeOf(AdpAdp)).apply(this, arguments));
  }

  _createClass(AdpAdp, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M1852.736 219.328h-128.128v127.808h128.128c30.464 0 54.656 24.768 54.656 55.04 0 30.336-24.192 54.784-54.656 54.784h-128.128v128.128h128.128c100.864 0 182.592-81.984 182.592-182.912-.064-100.864-81.728-182.848-182.592-182.848zm-729.28 676.48c152.896 0 285.056-89.728 346.752-219.584h163.008v219.584h91.392V676.224h128.128c151.424 0 273.984-122.816 273.984-274.048C2126.72 250.88 2004.16 128 1852.736 128h-219.52v328.96h-130.048C1476.8 270.976 1316.672 128 1123.456 128H673.408L225.856 895.808h106.88L460.48 676.224h460.096v219.584h202.88zm1131.456-493.632c0 221.952-180.288 401.92-402.176 401.92v219.456h-347.264V852.416c-94.016 105.152-230.208 171.136-382.016 171.136H792.512V804.096H534.016L406.08 1023.552H0L596.8 0h526.656c151.808 0 288 66.304 382.016 171.2V0h347.264c221.888 0 402.176 180.288 402.176 402.176zm-1462.4-182.848V456.96H588.544l-74.496 128.128H920.64v-365.76H792.512zM1416 511.68c0 161.472-131.072 292.416-292.48 292.416h-111.488V676.224h111.488c90.816 0 164.416-73.6 164.416-164.544 0-90.624-73.6-164.544-164.416-164.544h-111.488V219.328h111.488c161.408 0 292.48 130.88 292.48 292.352zm560.896 457.216v-14.72h10.56c7.04 0 9.216 2.24 9.216 6.656 0 4.288-2.112 7.936-10.24 8.128h-9.536zm7.552 8.96c2.944.384 5.952 0 8.128 2.432 2.56 2.496 2.56 7.04 3.264 12.096.576 3.2 1.28 6.912 2.048 10.24h11.328c-1.856-5.248-2.688-11.264-3.392-16.512-.832-6.4-1.728-9.92-9.856-11.328v-.384c7.936-1.664 11.84-6.848 11.84-13.312 0-12.992-10.944-15.872-21.248-15.872h-18.624v57.344h9.024v-24.704h7.488zm2.752 45.696c26.816 0 48.448-21.888 48.448-48.96 0-26.88-21.632-48.512-48.448-48.512-26.944 0-49.088 21.632-49.088 48.512.064 27.072 22.144 48.96 49.088 48.96zm0-8.832c-22.336 0-40.128-17.728-40.128-40.128 0-22.016 17.792-40.192 40.128-40.192 22.08 0 40.064 18.176 40.064 40.192a39.974 39.974 0 0 1-40.064 40.128z' })
        )
      );
    }
  }]);

  return AdpAdp;
}(_react2.default.Component);

AdpAdp.defaultProps = {
  viewBox: '0 0 2256 1043.776',
  height: '1em',
  width: '2.1614em'
};

exports.default = AdpAdp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/adp/adp.js
// module id = 222
// module chunks = 0 1 2 3 4 5 6